import { Injectable } from '@angular/core';
import { ClinicalResolution, ClinicalResolutionPagination } from 'src/app/models/clinical.model';
import { FirestoreService } from '../firestore.service';

@Injectable({
  providedIn: 'root',
})
export class CaseManagementService {
  constructor(private fsService: FirestoreService) {}

  async createClinicalAssessment(note: ClinicalResolution): Promise<void> {
    await this.fsService.add(`clinical_assessments`, note);
  }

  updateClinicalAssessment(note: ClinicalResolution): Promise<void> {
    return this.fsService.update(`clinical_assessments/${note.id}`, note);
  }

  deleteClinicalAssessment(noteId: string): Promise<void> {
    return this.fsService.delete(`clinical_assessments/${noteId}`);
  }

  /** Writes only the pin fields: the list's copy of the note can be older than the stored one (e.g. its time link). */
  pinClinicalAssessment(note: ClinicalResolutionPagination): Promise<void> {
    const { id, pinned, pinnedProperties } = note;
    return this.fsService.update(`clinical_assessments/${id}`, { pinned, pinnedProperties });
  }
}
